import type { Component, Entity2D } from '../../odie';

import { NestBlockProps } from '../defs/block';
import { NestBlockView } from '../views/blocks/NestBlockView';

// types
//-----------------------------------------------------------------------------
export type NestBlockComponentOptions = {
  props: NestBlockProps;
};

/*
    nest block component
*/
export class NestBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockNest';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: NestBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: NestBlockComponentOptions): void {
    // create view
    this.view = new NestBlockView(options.props);
  }
}
